import PocketBase from 'pocketbase';

const pb = (() => {
  const POCKETBASE_URL = (process.env.NEXT_PUBLIC_POCKETBASE_URL || '') + '/';
  return new PocketBase(POCKETBASE_URL);
})();

export default pb;